import ApiService from "./api.service";

const CorruptionReportService = {
  GetList(data) {
    return ApiService.post(`/CorruptionReport/GetList`, data);
  },
  Get(id) {
    if (id) return ApiService.get(`/CorruptionReport/Get/${id}`);
    return ApiService.get(`/CorruptionReport/Get`);
  },
  Create(data) {
    return ApiService.post(`/CorruptionReport/Create`, data);
  },
  UploadFile(file) {
    const fd = new FormData();
    fd.append("files", file);
    return ApiService.formData(`/CorruptionReport/UploadFile`, fd);
  },
  DownloadFile(fileId) {
    return ApiService.print(`/CorruptionReport/DownloadFile/${fileId}`);
  },
  DeleteFile(fileId) {
    return ApiService.post(`/CorruptionReport/DeleteFile/${fileId}`);
  },
  GetSecurityInfo() {
    return ApiService.get(`/CorruptionReport/GetSecurityInfo`);
  },
};

export default CorruptionReportService;
